import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'src/app/auth.guard';
import { GdoDesktopComponent } from './gdo-desktop.component';

const routes: Routes = [
  {
    path: '',
    component: GdoDesktopComponent,
    children: [
      {
        path: '',//canActivate: [AuthGuard],
        loadChildren: () =>
          //gdo products component and routing
          import('./gdo-product/gdo-product-routing.module').then(
            (m) => m.GdoProductRoutingModule
          ),
      },
      {
        path: 'gdo-product', //canActivate: [AuthGuard],
        loadChildren: () =>
          //gdo vehicle component and routing
          import('./gdo-vehicle/gdo-vehicle-routing.module').then(
            (m) => m.GdoVehicleRoutingModule
          ),
      },
      {
        path: 'billing', //canActivate: [AuthGuard],
        loadChildren: () =>
          // gdo payment component routing
          import('./gdo-payment/gdo-payment-routing.module').then(
            (m) => m.GdoPaymentRoutingModule
          ),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class GdoDesktopRoutingModule {}
